// extracted by mini-css-extract-plugin
module.exports = {"container":"nU5YQ","lds_ring":"_18rki","pink":"_36vRZ","danger":"_1pZe4","blue":"_24Cux","green":"_1Mm5a","white":"_1kOkz"};